import { ComponentProps } from "react";
import { Typography } from "antd";

export type UITypographyProps = ComponentProps<typeof Typography>;
export type UITypographyTitleProps = ComponentProps<typeof Typography.Title>;
export type UITypographyTextProps = ComponentProps<typeof Typography.Text>;
export type UITypographyParagraphProps = ComponentProps<typeof Typography.Paragraph>;

export const UITypography = (props: UITypographyProps) => <Typography {...props} />;
export const UITypographyTitle = (props: UITypographyTitleProps) => (
  <Typography.Title {...props} />
);
export const UITypographyText = (props: UITypographyTextProps) => <Typography.Text {...props} />;
export const UITypographyParagraph = (props: UITypographyParagraphProps) => (
  <Typography.Paragraph {...props} />
);
